module.exports = __webpack_public_path__ + "static/media/illustration-box-desktop.a7ef46ea.svg";